module.exports = require("core-js-pure/stable/instance/trim");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/trim.js
// module id = 549
// module chunks = 0 1